export const RESET_RESERVATION_AVAILABILITY = 'RESET_RESERVATION_AVAILABILITY';
export const RESET_RESERVATION_AVAILABILITY_ISFETCHING =
  'RESET_RESERVATION_AVAILABILITY_ISFETCHING';
export const LIST_RESERVATION_AVAILABILITIES_REQUEST =
  'LIST_RESERVATION_AVAILABILITIES_REQUEST';
export const RESERVATION_AVAILABILITY_REQUESTING =
  'RESERVATION_AVAILABILITY_REQUESTING';
export const LIST_RESERVATION_AVAILABILITIES_SUCCESS =
  'LIST_RESERVATION_AVAILABILITIES_SUCCESS';
export const LIST_RESERVATION_AVAILABILITIES_SUCCESS_GTM =
  'LIST_RESERVATION_AVAILABILITIES_SUCCESS_GTM';
export const RESERVATION_CLICK_SUCCESS_GTM = 'RESERVATION_CLICK_SUCCESS_GTM';
